import type { LocalizedString, SustainabilitySfdrScore } from "@repo/shared/types";

/**
 * Seed content written into a collection's sustainability config when SFDR is
 * enabled. Designers can edit the labels afterwards; the stored copy is what
 * the flow shows.
 */

/** Default en+nb labels for the three fixed SFDR scores. */
export const DEFAULT_SFDR_SCORES: SustainabilitySfdrScore[] = [
  { value: 6, labelI18n: { en_GB: "Article 6", nb_NO: "Artikkel 6" } },
  { value: 8, labelI18n: { en_GB: "Article 8", nb_NO: "Artikkel 8" } },
  { value: 9, labelI18n: { en_GB: "Article 9", nb_NO: "Artikkel 9" } },
];

/**
 * Default SFDR criterion label — this string is the QUESTION shown to the client
 * in the flow (their minimum required SFDR article), so it seeds as a question.
 */
export const DEFAULT_SFDR_QUESTION: LocalizedString = {
  en_GB: "What is the minimum SFDR category you want for your funds?",
  nb_NO: "Hvilken SFDR-kategori ønsker du som minimum for fondene dine?",
};
